import {mergeStyleSets, memoizeFunction} from "@fluentui/react"

export interface IThemePanelClassNames {
	root: string;
}

export const getClassNames = memoizeFunction((): IThemePanelClassNames => {
	return mergeStyleSets({
		root: {
			top: '50px',
			height: 'calc(100% - 50px)',
		},
	});
});
